import React, {Dispatch, SetStateAction} from "react";
import {GameApi} from "../../services/api/GameApi";
import {TFunction} from "i18next";

export abstract class GameComponent {

    constructor(protected finishGame: () => void) {}

    fetchWords(difficulty: Number|null, setText : React.Dispatch<React.SetStateAction<string[]>>) : void{
        GameApi.getText(difficulty!!)
            .then((words: string[]) => {
                setText(words);
            })
            .catch((error: any) => {
                console.error("Erreur lors de la récupération des mots :", error);
            });
    }

    abstract tick(prevTime: number): number;
    abstract onValidWord(currentScore: number): void;
    abstract getTimer(): number;
    abstract getBottomInfo(currentScore: number, time: number, resetGame: () => void, t: TFunction<"translation", undefined>): React.ReactNode;
    abstract getTopInfo(t: TFunction<"translation", undefined>, showInformationsPopup: () => void): React.ReactNode;
    abstract getInformationPopup(t: TFunction<"translation", undefined>, closePopup: Dispatch<SetStateAction<boolean>> ): React.ReactNode;
    abstract canUserPlay(t: TFunction<"translation", undefined>, userId: number, gameModeId: number): Promise<{canPlay: boolean, reason?: string}>;
    abstract getStatsFromApiResponse(t: TFunction<"translation", undefined>, response: any): any;

    shouldShowInformationPopupOnStart(): boolean {
        return false; 
    }
}